import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ConfigModule } from '@library/store/config/config.module';
import { HomesModule } from '@library/store/homes/homes.module';
import { LangModule } from '@library/store/lang/lang.module';
import { ModulesModule } from '@library/store/modules/modules.module';
import { UserFacade } from '@library/store/user/user.facade';
import { UserModule } from '@library/store/user/user.module';
import { ToUserUnitPipe } from '@library/utils/pipes/to-user-unit.pipe';
import { JAWG_ACCESS_TOKEN } from '@library/utils/services/jawgmaps.service';
import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideStore, StoreModule } from '@ngrx/store';
import { LangsResolver } from '@store/langs/langs.resolver';
import { WebappLangFacade } from '@store/langs/webapp-langs.facade';
import { WeathermapFacade } from '@store/weathermap.facade';
import {
  associateFavoriteStation$,
  dissociateFavoriteStation$,
  loadForecast$,
  loadHumidity$,
  loadPressure$,
  loadRain$,
  loadStation$,
  loadTemperature$,
  loadWind$,
  WeathermapReducers,
} from '@store/weathermap.store';
import { CookieService } from 'ngx-cookie-service';
import { WeathermapUserFacade } from 'src/app/services/weathermap-user-facade';
import { JawgToken } from 'src/app/weathermap.const';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideAnimations(),
    { provide: APP_BASE_HREF, useValue: '/' },
    importProvidersFrom([
      StoreModule.forRoot(),
      StoreModule.forFeature('weathermap', WeathermapReducers),
      EffectsModule.forRoot(),
      LangModule,
      ConfigModule,
      UserModule,
      HomesModule,
      ModulesModule,
    ]),
    CookieService,
    provideStore(
      {},
      {
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false,
        },
      },
    ),
    provideEffects({
      loadPressure$,
      loadTemperature$,
      loadHumidity$,
      loadWind$,
      loadRain$,
      loadForecast$,
      loadStation$,
      associateFavoriteStation$,
      dissociateFavoriteStation$,
    }),
    WeathermapFacade,
    WebappLangFacade,
    LangsResolver,
    { provide: JAWG_ACCESS_TOKEN, useValue: JawgToken },
    {
      provide: UserFacade,
      useClass: WeathermapUserFacade,
    },
    ToUserUnitPipe,
  ],
};
